// @material-ui/icons
import Email from "@material-ui/icons/Email";
import Audit from "@material-ui/icons/TrackChanges";
import SettingsPage from "views/Settings/Index.jsx";
import EmailSettings from "views/EmailSettings/Index.jsx";
import Settings from "@material-ui/icons/SettingsApplications";
import NotFound from "views/NotFound/Index.jsx";


const routes = [
    {
        path: "/app/settings",
        sidebarName: "Settings",
        navbarName: "Settings",
        subMenu: [
            {
                path: "/app/settings",
                sidebarName: "Re-order Level",
                navbarName: "Re-order Level",
                component: SettingsPage
            },
            {
                path: "/app/emailSettings",
                sidebarName: "Email Settings",
                navbarName: "Email Settings",
                icon: Email,
                component: EmailSettings
            },
        ],
        icon: Settings,
        component: SettingsPage
    },
    {
        path: "/app/settings",
        sidebarName: "Re-order Level",
        navbarName: "Re-order Level",
        isNotVisible: true,
        component: SettingsPage,
        subMenu: [],

    },
    {
        path: "/app/emailSettings",
        sidebarName: "Email Settings",
        navbarName: "Email Settings",
        icon: Email,
        isNotVisible: true,
        component: EmailSettings,
        subMenu: [],

    },
    {
        isNotVisible: true,
        path: "**",
        sidebarName: "Not found",
        navbarName: "Not Found",
        icon: Audit,
        subMenu: [],
        component: NotFound,

    }
    ];

export default routes;



// WEBPACK FOOTER //
// ./src/routes/admin.jsx